import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import Product from '../views/Product.vue'
// import Office from '../views/Document.vue'
// import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/product',
        name: 'Product',
        component: () => import('../views/Product.vue'),
        children: [
            {
                path: '',  // 动态路由：/product/1
                name: 'ProductList',
                component: () => import('../views/ProductList.vue'),
            },
            {
                path: '/productDetail',
                name: 'ProductDetail',
                component: () => import('../views/ProductDetail.vue'),
                props: (route) => ({
                    // 传递路由参数
                    productId: parseInt(route.params.id)
                })
            }
        ]
    },
    {
        path: '/document',
        name: 'Document',
        component: () => import('../views/Document.vue'),
    },
    {
        path: '/documentDetail',
        name: 'DocumentDetail',
        component: () => import('../views/DocumentDetail.vue'),
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/Contact.vue')
    },
    {
        path: '*',
        redirect: '/'  // 404 页面重定向
    }
]

const router = new VueRouter({
    mode: 'history',  // 可选：history 模式（需要服务器支持）或 hash 模式
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 路由切换时滚动到顶部
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router